/**
*
* HeatMap
*
*/

import HeatMap from './HeatMap.jsx'
import './HeatMap.less'

export default HeatMap